export default "__VITE_ASSET__CqzxiJ8N__"